import { Component, OnInit, Inject, forwardRef } from '@angular/core';
// import { config } from '../config';
import { AppComponent } from '../app.component';
import * as d3 from "d3";

@Component({
  selector: 'front-jacket',
  templateUrl: './front-jacket.component.html',
  styleUrls: ['./front-jacket.component.css']
})
export class FrontJacketComponent implements OnInit {
  // private svg : any = new SVGAElement();

  constructor(@Inject(forwardRef(() => AppComponent)) public parent : AppComponent) {

    // svg.setAttribute("xlink:href", "file:///D:/d3js_projects/refresh.png");
    // svg.setAttribute("x", "60");
    // svg.setAttribute("y", "60");
    // svg.setAttribute("width", "20");
    // svg.setAttribute("height", "20");
    // console.log('svg : ', this.svg)
   }
  
  ngOnInit() {
    this.parent.applyDesignOnJacket();
    /*
    var imgs = d3.select(".custom_front-top-right")
    .append("svg")
    .attr("x", "325")
    .attr("y", "185")
    .attr("width", "93.73")
    .attr("height", "100.27")
    .attr("viewBox", "0 0 256 256")
    .append("text")
    .text('Jassy')
    .attr("color", "#f00")
    .attr("font-size", "50px")

*/

    // .style({color : '#f00', 'font-size' : '20px'})
    /*.attr("xlink:href", "assets/images/patch-image1.png")
    .attr("x", "0")
    .attr("y", "0")
    .attr("width", "256")
    .attr("height", "256")*/
/*
    var imgs1 = d3.select(".custom_front-top-left")
    .append("svg")
    .attr("x", "184")
    .attr("y", "185")
    .attr("width", "93.73")
    .attr("height", "100.27")
    .attr("viewBox", "0 0 256 256")
    .append("image")
    .attr("xlink:href", "assets/images/patch-image1.png")
    .attr("x", "0")
    .attr("y", "0")
    .attr("width", "256")
    .attr("height", "256")

    var imgs2 = d3.select(".custom_front-bottom-left")
    .append("svg")
    .attr("x", "196")
    .attr("y", "357")
    .attr("width", "76.73")
    .attr("height", "100.27")
    .attr("viewBox", "0 0 256 256")
    .append("image")
    .attr("xlink:href", "assets/images/patch-image1.png")
    .attr("x", "0")
    .attr("y", "0")
    .attr("width", "256")
    .attr("height", "256")

    var imgs3 = d3.select(".custom_front-bottom-right")
    .append("svg")
    .attr("x", "316")
    .attr("y", "357")
    .attr("width", "76.73")
    .attr("height", "100.27")
    .attr("viewBox", "0 0 256 256")
    .append("image")
    .attr("xlink:href", "assets/images/patch-image1.png")
    .attr("x", "0")
    .attr("y", "0")
    .attr("width", "256")
    .attr("height", "256");
*/

   
  }
}



// WEBPACK FOOTER //
// /Users/jaswantdhayal/Desktop/Projects/seniorJackets/src/app/front-jacket/front-jacket.component.ts